import { render, staticRenderFns } from "./FreeWagers.vue?vue&type=template&id=28b07217&scoped=true&"
import script from "./FreeWagers.vue?vue&type=script&lang=js&"
export * from "./FreeWagers.vue?vue&type=script&lang=js&"
import style0 from "./FreeWagers.vue?vue&type=style&index=0&id=28b07217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b07217",
  null
  
)

export default component.exports